import { useDisclosure } from "@mantine/hooks";

import { useSalesContext } from "../../../sales-context/SalesContext";

export function useStatsDrawer() {
    const [opened, { open, close }] = useDisclosure(false);
    const { analytics } = useSalesContext();

    const handleClose = (source: string) => {
        void analytics.dispatcher.dispatchBusinessEvent("CloseExpertPerformanceDashboard", { source });
        close();
    };

    const handleOpen = (source: string) => {
        void analytics.dispatcher.dispatchBusinessEvent("OpenExpertPerformanceDashboard", { source });
        open();
    };

    const toggle = (source: string, canOpen: boolean) => {
        if (opened) {
            handleClose(source);
        } else if (canOpen) {
            handleOpen(source);
        }
    };

    return {
        opened,
        handleOpen,
        handleClose,
        toggle,
    };
}
